module.exports = __webpack_public_path__ + "img/listhosp.e620e6af.png";